import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchAuth = createAsyncThunk(
  'auth/fetchAuth',
  async (_, { rejectWithValue }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-type", "application/json");
      myHeaders.append("username", "admin@kbk");
      myHeaders.append("password", "admin786");
      myHeaders.append("code", "1");

      const formdata = new FormData();

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };

      const response = await fetch("https://api.mdm.pitc.com.pk/api/authorization_service", requestOptions);

      const text = await response.json()

      if (!response.ok) {
        throw new Error(text || "Authentication failed!");
      }

      return text;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    resetAuthState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuth.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAuth.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchAuth.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Unknown error occurred";
      });
  },
});

export const { resetAuthState } = authorizationSlice.actions;

export default authorizationSlice.reducer;
